module.exports = __webpack_public_path__ + "img/2_การเตรียมข้อมูล.21ac28fc.png";